import Vue from "vue";
import App from "./App.vue";
import router from "../router";
import store from "../store";
//全局请求
import request from "./utils/request";
import {
  Button,
  Form,
  FormItem,
  Input,
  Message,
  Card,
  Icon,
  Container,
  Aside,
  Menu,
  MenuItem,
  Submenu,
  Header,
  Row,
  Col,
  Tabs,
  Breadcrumb,
  Badge,
  Dropdown,
  DropdownItem,
  Main,
  Tag,
  BreadcrumbItem,
  DropdownMenu,
  Table,
  TabPane,
  TableColumn,
  Footer,
  MessageBox,
  Empty,
  Pagination,
  Loading,
  Select,
  Option,
  Dialog,
  Switch,
  DatePicker,
  Divider,
  Descriptions,
  DescriptionsItem,
  Tooltip,
  Popover,
  Notification,
  Timeline,
  TimelineItem,
  Image,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// 注意：导入的组件都需要使用 Vue.use() 进行注册
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Card);
Vue.use(Icon);
Vue.use(Container);
Vue.use(Aside);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(Header);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tabs);
Vue.use(Submenu);
Vue.use(Breadcrumb);
Vue.use(Badge);
Vue.use(DropdownItem);
Vue.use(Dropdown);
Vue.use(Main);
Vue.use(Tag);
Vue.use(BreadcrumbItem);
Vue.use(DropdownMenu);
Vue.use(Table);
Vue.use(TabPane);
Vue.use(TableColumn);
Vue.use(Footer);
Vue.use(Empty);
Vue.use(Pagination);
Vue.use(Loading);
Vue.use(Select);
Vue.use(Option);
Vue.use(Dialog);
Vue.use(Switch);
Vue.use(DatePicker);
Vue.use(Divider);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Tooltip);
Vue.use(Popover);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Image);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
//数据大屏
import dataV from "@jiaminghi/data-view";
Vue.use(dataV);
// 系统配置
import global from "./utils/Global"; // 全局配置参数
import tools from "./utils/tools"; //封装工具类
Vue.prototype.$GLOBAL = global;
Vue.prototype.$http = request;
Vue.prototype.$tools = tools;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.config.productionTip = false;
router.beforeEach((to, form, next) => {
  const token = localStorage.getItem("access_token");
  if (!token && to.name != "login") {
    // 获取登录的状态
    next({ name: "login" });
  } else if (token && to.name == "login") {
    //登录后不再访问login页面
    next({ name: "home" });
  } else {
    next(); //直接放行
  }
  // console.log(to)
  //拦截大屏页面，如果name是smartview就在新窗口打开
  if (to.name === "smartview") {
    next(false); // 终止当前导航
  }
  //导航守卫根据token跳转登录页面
  if (to.meta.title) {
    document.title = to.meta.title + "-嘉恒财务结算企业端" || "启明星软件"; //获取路由的页面标题
  }
  //    store.commit('get_token');
  if (form.name != "detail" && to.name == "jobdo") {
    localStorage.removeItem("PSquery");
  }
  if (form.name != "jsdetail" && to.name == "rentdo") {
    localStorage.removeItem("JSquery");
  }
});
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
